"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientHydration = exports.startApplication = void 0;
exports.loadCodesplitIfNeeded = loadCodesplitIfNeeded;
var tslib_1 = require("tslib");
var bernie_core_1 = require("bernie-core");
var bernie_view_1 = require("bernie-view");
var get_client_plugins_1 = require("bernie-plugins/dist/load/get-client-plugins");
var browser_1 = require("bernie-plugins/dist/execute/browser");
var React = require("react");
var react_dom_1 = require("react-dom");
var react_router_dom_1 = require("react-router-dom");
var react_router_dom_v5_compat_1 = require("react-router-dom-v5-compat");
var bernie_client_events_1 = require("../../events/bernie-client-events");
var logger_1 = require("../../logger");
var controller_life_cycle_1 = require("./controller-life-cycle");
var dialog_utils_1 = require("../../util/dialog-utils");
var browser_compat_1 = require("../../util/browser-compat");
var logger = logger_1.ClientLogger.getLoggerWithIdentifier('bernie.client.hydrate');
var startApplication = function () {
  return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var plugins, appData, analytics, stores, controllers, pageDataContext, _a, baseUrl, appName, matchedRoute, route, component, storeContainer, routes, appContainerId, renderApp, appContainer, wrapRootElementResult, RootElement;
    return tslib_1.__generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          (0, dialog_utils_1.preventShortTermDialogOpening)();
          (0, browser_compat_1.pseudoStylingFixForSafari)();
          plugins = (0, get_client_plugins_1.getClientPlugins)();
          return [4 /*yield*/, (0, browser_1.onBrowserHydrateRenderContext)(plugins, {
            appData: {},
            logger: logger,
            state: window.__PLUGIN_STATE__
          })];
        case 1:
          appData = _b.sent().appData;
          analytics = appData.analytics, stores = appData.stores, controllers = appData.controllers, pageDataContext = appData.pageDataContext;
          _a = pageDataContext || {}, baseUrl = _a.baseUrl, appName = _a.appName;
          matchedRoute = (0, bernie_core_1.matchRoute)(controllers, location.pathname, {
            baseUrl: baseUrl
          });
          route = matchedRoute.route;
          component = route.component;
          storeContainer = new bernie_core_1.StoreContainer(stores);
          routes = controllers.map(function (controller) {
            return (0, controller_life_cycle_1.setupControllerLifeCycleCallbacks)(appData, baseUrl, storeContainer, controller, logger);
          });
          return [4 /*yield*/, loadCodesplitIfNeeded(component)];
        case 2:
          _b.sent();
          appContainerId = appName ? "app-".concat(appName) : 'app';
          renderApp = function (props) {
            return React.createElement(bernie_view_1.Application, tslib_1.__assign({}, props, {
              routes: routes,
              analytics: analytics,
              applicationContainerId: appContainerId
            }));
          };
          appContainer = document.getElementById(appContainerId);
          return [4 /*yield*/, (0, browser_1.onBrowserWrapRootElement)(plugins, {
            appData: appData,
            logger: logger
          })];
        case 3:
          wrapRootElementResult = _b.sent();
          RootElement = wrapRootElementResult.result.RootElement;
          (0, react_dom_1.hydrate)(React.createElement(react_router_dom_1.BrowserRouter, {
            basename: baseUrl
          }, React.createElement(react_router_dom_v5_compat_1.CompatRouter, null, React.createElement(RootElement, null, React.createElement(react_router_dom_1.Switch, null, React.createElement(react_router_dom_v5_compat_1.CompatRoute, {
            path: "*",
            exact: true,
            render: renderApp
          }))))), appContainer, function () {
            // Final fallback check should everything blow up
            if (appContainer && appContainer.innerHTML === '') {
              appContainer.innerHTML = bernie_view_1.Application.fallbackContent || '';
            }
          });
          return [2 /*return*/];
      }
    });
  });
};
exports.startApplication = startApplication;
function loadCodesplitIfNeeded(component) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var error_1;
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!(component.prototype instanceof bernie_core_1.CodeSplit && component.componentLoaded !== true)) return [3 /*break*/, 4];
          _a.label = 1;
        case 1:
          _a.trys.push([1, 3,, 4]);
          return [4 /*yield*/, component.loadRoute()];
        case 2:
          _a.sent();
          return [3 /*break*/, 4];
        case 3:
          error_1 = _a.sent();
          logger.logEvent(bernie_client_events_1.BERNIE_CLIENT_EVENTS.COMPONENT_LOAD_ROUTE_ERROR, error_1);
          return [3 /*break*/, 4];
        case 4:
          return [2 /*return*/];
      }
    });
  });
}
var clientHydration = function () {
  return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var startTime, endTime;
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          startTime = getTime();
          _a.label = 1;
        case 1:
          _a.trys.push([1,, 3, 4]);
          return [4 /*yield*/, (0, exports.startApplication)()];
        case 2:
          _a.sent();
          return [3 /*break*/, 4];
        case 3:
          endTime = getTime();
          logger.logEvent(bernie_client_events_1.BERNIE_CLIENT_EVENTS.APP_HYDRATION_COMPLETE, {
            pageHydrated: startTime,
            time: endTime - startTime
          });
          return [7 /*endfinally*/];
        case 4:
          return [2 /*return*/];
      }
    });
  });
};
exports.clientHydration = clientHydration;
function getTime() {
  var _a;
  return ((_a = window === null || window === void 0 ? void 0 : window.performance) === null || _a === void 0 ? void 0 : _a.now) ? window.performance.now() : Date.now();
}